export const Href = ({ children, href }: { children: string; href: string }) => {
  return <a href={href}>{children}</a>;
};
